import {MarginItem} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {FormGroup} from "components/UIComponents/FormGroup";
import {FormattedMessage} from "react-intl";
import {menuEditorActions} from "../editorSlice";
import {useAppDispatch} from "lib/redux/hooks";
import {SubTitle} from "components/UIComponents/SubTitle";
import {EditorItem} from "../editorUtils";
import {EditorGroup} from "./EditorGroup";
import {Slider} from "../../../components/UIComponents/Slider";

export interface MarginEditorProps {
    margin: EditorItem<MarginItem>
}

export function MarginEditor(props: MarginEditorProps): ReactElement {
    const dispatch = useAppDispatch();
    const itemKey = props.margin.itemKey;
    const marginItem = props.margin.menuItem;
    const updateMargin = (margin: number) => {
        dispatch(menuEditorActions.editItem({
            key: itemKey,
            newItem: {type: 'margin', height: margin} as MarginItem,
        }));
    }

    return (
        <EditorGroup>
            <SubTitle><FormattedMessage id="editor.margin"/></SubTitle>
            <FormGroup groupTitle={<><FormattedMessage id="editor.margin.margin"/> ({marginItem.height}mm)</>}>
                <Slider
                    min={5}
                    max={170}
                    value={marginItem.height}
                    onChange={updateMargin}
                />
            </FormGroup>
        </EditorGroup>
    );
}